import helper from "@/form_builder/components/form/ui/helper.js";

export default {
  vue_tag: "input",
  tag: "el-input",
  name: "Tipo Texto",
  title:
    "Tipo de campo TEXTO que permite incorporar datos como llenado de entidad donde trabaja, cargo que ocupa, etc.",
  __openRules: true,
  tagIcon: "input",
  __ID: "",
  defaultvalue: "",

  formItem: {
    showLabel: helper.input_boolean("Mostrar etiqueta", true),
    // labelWidth: helper.input_number("Ancho etiqueta", 100),
    label: helper.input_text("Etiqueta", "Campo"),
  },
  attrs: {
    fieldName: helper.input_text("Nombre de campo", "nombre de campo"),
    placeholder: helper.input_text("Ejemplo de entrada", "Ingrese valor"),
    type: helper.input_select(
      "Tipo",
      [
        {
          key: "text",
          value: "Texto",
        },
        {
          key: "textarea",
          value: "Área de texto",
        },
        {
          key: "password",
          value: "Contraseña",
        },
        {
          key: "number",
          value: "Número",
        },
      ],
      "text"
    ),
  },

  props: {},

  childrens: [],
  ctrlBtn: true,
  slots: {
    prefix: helper.input_text("box header", ""),
    suffix: helper.input_text("content at the end", ""),
    prepend: helper.input_text("box prepend", ""),
    append: helper.input_text("content after", ""),
  },

  rule: {
    required: helper.input_boolean("必填", false),
  },
};
